// extracted by mini-css-extract-plugin
module.exports = {"container":"SfF2X","title":"_3Zu1o","text":"XyQe_","button":"_2MsF6"};